export default function Plot_Graphics() {
  return (
    <div>
      <h1>Plot_Graphics Component</h1>
    </div>
  );
}
